import React from 'react';
import AudioPlayer from './AudioPlayer';
import useInterval from '../hooks/Interval';

export type AudioControlContextType = {
  isPlaying: boolean,
  currentPosition: number,
  duration: number,
  doPlay: () => void,
  doPause: () => void,
  doSeek: (progress: number) => void,
};

export const AudioControlContext = React.createContext<AudioControlContextType>({
  isPlaying: false,
  currentPosition: 0,
  duration: 0,
  doPlay: () => {},
  doPause: () => {},
  doSeek: (progress: number) => {},
});

export default function AudioControl({
  url,
  children,
}: {
  url: string,
  children?: React.ReactNode
}) {
  const [isPlaying, setIsPlaying] = React.useState(false);
  const [currentPosition, setCurrentPosition] = React.useState(0);
  const [duration, setDuration] = React.useState(0);

  useInterval(() => {
    const newIsPlaying = (AudioPlayer.isPlaying() && AudioPlayer.getPlayingUrl() === url);
    setIsPlaying(newIsPlaying);
    setCurrentPosition(newIsPlaying ? AudioPlayer.getCurrentPosition() : 0);
    setDuration(newIsPlaying ? AudioPlayer.getDuration() : 0);
  }, 1000);

  const audioControlContextValue = {
    isPlaying,
    currentPosition,
    duration,
    doPlay: () => {
      AudioPlayer.play(url);
    },
    doPause: () => {
      AudioPlayer.pause();
    },
    doSeek: (progress: number) => {
      AudioPlayer.setCurrentPosition(progress * AudioPlayer.getDuration());
    },
  };

  return (
    <AudioControlContext.Provider value={audioControlContextValue}>
      {children}
    </AudioControlContext.Provider>
  );
}
